import {
  ArtevicImg,
  ChicImg,
  ElorvaImg,
  MosonImg,
} from "@/assets/images/image";
import { HouseRule } from "@/lib/types";

// How Octarnal actually works, stated as positions rather than services — and
// each one carrying the piece of work that proves it. The images are the same
// case-study covers used elsewhere on the site, so nothing new is claimed here
// that a visitor cannot go and check.
export const houseRules: HouseRule[] = [
  {
    number: "01",
    rule: "One team, start to ship",
    detail:
      "The people in the first call are the people writing the code and drawing the screens. Nothing gets handed down a chain and diluted on the way.",
    proof: "Moson Media — SaaS growth engine",
    image: MosonImg,
    href: "/case-study/moson-media",
  },
  {
    number: "02",
    rule: "Every pixel earns its place",
    detail:
      "Beauty is not decoration here. Each frame, transition and line of type is there because it moves someone closer to buying, booking or believing.",
    proof: "Elorva — luxury fragrance commerce",
    image: ElorvaImg,
    href: "/case-study/elorva-perfumes",
  },
  {
    number: "03",
    rule: "You own all of it",
    detail:
      "Files, code, accounts, the lot — handed over clean and documented. No hostage keys, no licence you have to keep paying us to renew.",
    proof: "Artevic — cinematic content studio",
    image: ArtevicImg,
    href: "/case-study/artevic-media",
  },
  {
    number: "04",
    rule: "Built to outlive the launch",
    detail:
      "Anyone can ship a launch-day screenshot. We build the thing that still converts in month eighteen, and we stay close enough to prove it.",
    proof: "Chic & Charming — brand experience",
    image: ChicImg,
    href: "/case-study/chic-charming",
  },
];
